$(document).on('ready', function() {
   $('#footer ul.Fc a').each(function(i, e) {
       if ($(e).attr('href').indexOf('page=') > -1) {

           $(e).attr('href', $(e).attr('href') + window.location.pathname + window.location.search);
       }
    });
});